var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#2DB0D8",
    fillOpacity: 0.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8571 23.1429H23.1429V28.8571C23.1429 29.1602 23.0224 29.4509 22.8081 29.6653C22.5938 29.8796 22.3031 30 22 30C21.6969 30 21.4062 29.8796 21.1919 29.6653C20.9776 29.4509 20.8571 29.1602 20.8571 28.8571V23.1429H15.1429C14.8398 23.1429 14.5491 23.0224 14.3347 22.8081C14.1204 22.5938 14 22.3031 14 22C14 21.6969 14.1204 21.4062 14.3347 21.1919C14.5491 20.9776 14.8398 20.8571 15.1429 20.8571H20.8571V15.1429C20.8571 14.8398 20.9776 14.5491 21.1919 14.3347C21.4062 14.1204 21.6969 14 22 14C22.3031 14 22.5938 14.1204 22.8081 14.3347C23.0224 14.5491 23.1429 14.8398 23.1429 15.1429V20.8571H28.8571C29.1602 20.8571 29.4509 20.9776 29.6653 21.1919C29.8796 21.4062 30 21.6969 30 22C30 22.3031 29.8796 22.5938 29.6653 22.8081C29.4509 23.0224 29.1602 23.1429 28.8571 23.1429Z",
    fill: "#2DB0D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.ba464032e62e1ac73fd7cf7365cdfde0.svg";
export { ForwardRef as ReactComponent };